import './AddUserInfo.css';
import React, { useState }  from "react";
import updateUserData from '../../../assets/functions/updateUserData'


function EditRoutine(props) {
        const [routineList, setRoutineList] = useState((props.type === "evening" ? props.userProfile.eveningRoutineSteps : props.userProfile.morningRoutineSteps))
        const [showMaxStepReached, setShowMaxStepReached] = useState(false)
        function updateUserDataWithRoutine() {
            if (props.type==="evening") {
                updateUserData("updateEveningRoutine", routineList, props.userProfile, props.setUserProfile, props.closeFunction)
            } else {
                updateUserData("updateMorningRoutine", routineList, props.userProfile, props.setUserProfile, props.closeFunction)
            }
       
    }

    const handleRoutineChange = (index, event) => {
        let placeholderRoutine = [...routineList]
        placeholderRoutine[index] = event.target.value
        setRoutineList(placeholderRoutine)
    }

    function addStep() {
        let placeholderRoutine = [...routineList]
        if (placeholderRoutine.length < 8) {
            placeholderRoutine.push("")
        } else {
            setShowMaxStepReached(true)
        }
        setRoutineList(placeholderRoutine)
    }

    function deleteStep() {
        let placeholderRoutine = [...routineList]
        placeholderRoutine.pop()
        setRoutineList(placeholderRoutine)
        setShowMaxStepReached(false)
    }

      return (
        <div>
            {
                routineList.map((routine, index) => (
                    <div>
                    <p className="addProjectTextHeader">step {index+1}</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id={"routineText"+index}
                    value={routine}
                    onChange={(e) => handleRoutineChange(index, e)}
                    name={"routineText"+index}
                    spellCheck="false"
                    />
                </div>
                ))
            }
            {showMaxStepReached &&
                <p className="maxStepsReachedText"> 8 is the maximum number of steps!</p>
            }
            <div className="pillarButtonRow">
                <p className="addProfileInfoButton" onClick={() => addStep()}> add a step </p>
                <p className="addProfileInfoButton" onClick={() => deleteStep()}> delete last step </p>
            </div>
            <div className="pillarButtonRow">
                <p className="addProfileInfoButton" onClick={() => updateUserDataWithRoutine()}> save steps </p>
            </div>
        </div>  
    )
}

export default EditRoutine;